<template>
  <gg-card>
    <gg-card-header>
      Migration #{{ migration.id }}
    </gg-card-header>
    <gg-card-text>
      <v-row>
        <v-col cols="12" sm="3">
          <div>{{ migration.service_name }}</div>
        </v-col>
        <v-col cols="12" sm="3">
          {{ migration.event_title }}
        </v-col>
        <v-col cols="12" sm="3" class="text-capitalize text-center">
          <v-icon small class="mb-1" :color="migration.status_color">
            mdi-circle
          </v-icon>
          {{ migration.status }}
        </v-col>
        <v-col cols="12" sm="3">
          <gg-btn :to="{ name: 'migration_details', params: { id: migration.id } }">View Details</gg-btn>
        </v-col>
      </v-row>
      <template v-if="hasSubaccounts">
        <v-row>
          <v-col cols="12" class="font-weight-bold">
            Subaccounts:
          </v-col>
        </v-row>
        <v-row v-for="subMigration in migration.subaccounts" :key="`subM-${subMigration.id}`">
          <v-col cols="12" sm="3">
            <div>{{ subMigration.resold_username }}</div>
          </v-col>
          <v-col cols="12" sm="3">
            {{ subMigration.completed_at }}
          </v-col>
          <v-col cols="12" sm="3" class="text-capitalize text-center">
            <v-icon small class="mb-1" :color="migrationStatusColor(subMigration.status)">
              mdi-circle
            </v-icon>
            {{ subMigration.status }}
          </v-col>
        </v-row>
      </template>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { migrationStatusColor } from 'Helpers/helpers'

export default {
  name: 'MigrationsListItem',
  props: {
    migration: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasSubaccounts () {
      return Array.isArray(this.migration?.subaccounts) && this.migration.subaccounts.length > 0
    }
  },
  methods: {
    migrationStatusColor,
  }
}
</script>
